import './productList.scss';

import { FormattedMessage } from 'react-intl';

import { useHubProductList } from '~hooks';
import { ProductCard } from '~molecules';
import { HubProduct } from '~types/appsync.types';

interface ProductListProps {
  /** Called when the "Discover" button is clicked. */
  onDiscoverButtonClick: (productCategoryShortname: string) => void;
}

/** Description du composant ProductList */
export const ProductList = ({ onDiscoverButtonClick }: ProductListProps) => {
  const [products, loading, error] = useHubProductList();

  const displayProductList = (products: Array<HubProduct>) => {
    return products.map((product: HubProduct) => {
      if (!product.listing) {
        return null;
      }

      return (
        <ProductCard
          key={product.slug}
          product={product}
          onDiscoverButtonClick={onDiscoverButtonClick}
        />
      );
    });
  };

  if (loading) {
    return (
      <p>
        <FormattedMessage id='loading' defaultMessage='Loading...' />
      </p>
    );
  }
  if (error) {
    return (
      <p>
        <FormattedMessage id='error' defaultMessage='Error' /> : {error.message}
      </p>
    );
  }
  if (!products?.length) {
    return (
      <p>
        <FormattedMessage id='noData' defaultMessage='No data found' />
      </p>
    );
  }

  return (
    <section className='ProductList' aria-label='liste des produits'>
      <h2 className='visually-hidden'>Nos produits</h2>
      <div className='ProductList_title'>
        <span className='ProductList_title_found'>
          <FormattedMessage id='found' defaultMessage='we found' />
          &nbsp;
        </span>
        <span className='ProductList_title_results'>
          <FormattedMessage
            id='results'
            defaultMessage='results'
            values={{ count: products.length }}
          />
        </span>
      </div>
      <ul className='ProductList_items'>{displayProductList(products)}</ul>
    </section>
  );
};
